import { Card, CardContent } from "@/components/ui/card";
import React from "react";
import WorklistItemCard, { Priority, WorklistItemData, WorklistStatus } from "./worklist-item-card";

const worklistItems: WorklistItemData[] = [
    {
        status: WorklistStatus.PENDING,
        title: "Amoxicillin 500mg",
        subtitle: "BATCH-2024-001",
        priority: Priority.HIGH_PRIORITY,
        units: 50,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Paracetamol 500mg",
        subtitle: "BATCH-2024-002",
        priority: Priority.HIGH_PRIORITY,
        units: 120,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Ibuprofen 400mg",
        subtitle: "BATCH-2024-003",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 75,
    },
    {
        status: WorklistStatus.IN_PROGRESS,
        title: "Aspirin 100mg",
        subtitle: "BATCH-2024-004",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 200,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Metformin 850mg",
        subtitle: "BATCH-2024-005",
        priority: Priority.HIGH_PRIORITY,
        units: 90,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Omeprazole 20mg",
        subtitle: "BATCH-2024-006",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 60,
    },
    {
        status: WorklistStatus.COMPLETED,
        title: "Lisinopril 10mg",
        subtitle: "BATCH-2024-007",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 45,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Atorvastatin 20mg",
        subtitle: "BATCH-2024-008",
        priority: Priority.HIGH_PRIORITY,
        units: 80,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Amlodipine 5mg",
        subtitle: "BATCH-2024-009",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 110,
    },
    {
        status: WorklistStatus.IN_PROGRESS,
        title: "Losartan 50mg",
        subtitle: "BATCH-2024-010",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 65,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Simvastatin 40mg",
        subtitle: "BATCH-2024-011",
        priority: Priority.HIGH_PRIORITY,
        units: 55,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Furosemide 40mg",
        subtitle: "BATCH-2024-012",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 85,
    },
    {
        status: WorklistStatus.COMPLETED,
        title: "Warfarin 5mg",
        subtitle: "BATCH-2024-013",
        priority: Priority.HIGH_PRIORITY,
        units: 30,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Digoxin 0.25mg",
        subtitle: "BATCH-2024-014",
        priority: Priority.HIGH_PRIORITY,
        units: 25,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Ramipril 5mg",
        subtitle: "BATCH-2024-015",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 70,
    },
    {
        status: WorklistStatus.IN_PROGRESS,
        title: "Bisoprolol 2.5mg",
        subtitle: "BATCH-2024-016",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 95,
    },
    {
        status: WorklistStatus.PENDING,
        title: "Clopidogrel 75mg",
        subtitle: "BATCH-2024-017",
        priority: Priority.HIGH_PRIORITY,
        units: 40,
    },
    {
        status: WorklistStatus.COMPLETED,
        title: "Lansoprazole 30mg",
        subtitle: "BATCH-2024-018",
        priority: Priority.NON_HIGH_PRIORITY,
        units: 105,
    },
];

const Component: React.FC = () => {
    return (
        <div className="flex flex-col items-start justify-start p-4 w-full">
            <Card className="bg-[#FFFFFF] relative border rounded-2xl w-full">
                <CardContent className="w-full p-6 flex flex-col items-start justify-start gap-y-2">
                    <span className="font-semibold text-xl">Back EPack Worklist</span>
                    <span className="font-normal text-base text-gray-400 mb-4">Process stock back pack items and manage locations</span>
                    {worklistItems.map((item, index) => (
                        <WorklistItemCard key={index} {...item} />
                    ))}
                </CardContent>
            </Card>
        </div>
    );
};

export default Component;